import "./HiPainter.css";
import React from "react";
import {
	Segment,
	Image,
	Grid,
	Icon,
	Button,
	Label,
	Popup,
	Checkbox,
	Dropdown,
} from "semantic-ui-react";
import { SketchField, Tools } from "react-sketch";
import { SketchPicker } from "react-color";

class HiPainter extends React.Component {
	state = {
		bg: null,
		tool: Tools.Pencil,
		lineCol: "#000",
		fillCol: "#36EAB7",
		isFill: false,
		lineWidth: 3,
		openLW: false,
		bgCol: "transparent",
		text: "Shivam",
	};

	componentDidMount() {
		this.setBGImg();
	}

	setBGImg = () => {
		if (!this.props.photo) {
			return null;
		}
		let bg = this.props.photo.src;
		if (this.props.croppedImg) {
			bg = this.props.croppedImg.src;
		}

		console.log("Cropped IMG");
		console.log(this.props.croppedImg);

		if (!this._sketch) {
			return null;
		}
		this._sketch.setBackgroundFromDataUrl(bg, {
			stretched: true,
			stretchedX: false,
			stretchedY: false,
			originX: "left",
			originY: "top",
		});
	};

	renderDots = () => {
		const lws = [3, 5, 7, 9, 11, 13, 15, 17, 19, 21];
		return lws.map((lw) => {
			return (
				<div
					className="dotBtn"
					onClick={() =>
						this.setState({ lineWidth: lw, openLW: false })
					}
				>
					<div
						style={{
							width: lw,
							height: lw,
							borderRadius: "20px",
							backgroundColor: "black",
						}}
					/>
				</div>
			);
		});
	};

	_download = () => {
		var link = document.createElement("a");
		link.download = "Photo.png";
		link.href = this._sketch.toDataURL();
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	getBGOptions = () => {
		return ["transparent", "white", "black"].map((op) => {
			return {
				key: op,
				text: op,
				value: op,
			};
		});
	};

	_addText = () => {
		this._sketch.addText(this.state.text);
		this.setState({ tool: Tools.Select });
	};

	render() {
		if (!this.props.photo) {
			// return null;
		}

		console.log("Rendering Painter");
		this.setBGImg();

		const photo = this.props.photo;

		return (
			<Grid padded="vertically">
				<Grid.Column>
					<div
						style={{
							position: "relative",
						}}
					>
						<Button
							icon
							primary={this.state.tool === Tools.Pencil}
							onClick={() =>
								this.setState({ tool: Tools.Pencil })
							}
						>
							<Icon name="pencil" />
						</Button>
						<Button
							icon
							primary={this.state.tool === Tools.Line}
							onClick={() => this.setState({ tool: Tools.Line })}
						>
							<Icon name="arrows alternate vertical" />
						</Button>
						<Button
							icon
							primary={this.state.tool === Tools.Circle}
							onClick={() =>
								this.setState({ tool: Tools.Circle })
							}
						>
							<Icon name="circle outline" />
						</Button>
						<Button
							icon
							primary={this.state.tool === Tools.Rectangle}
							onClick={() =>
								this.setState({ tool: Tools.Rectangle })
							}
						>
							<Icon name="square outline" />
						</Button>
						<Button
							icon
							primary={this.state.tool === Tools.Select}
							onClick={() =>
								this.setState({ tool: Tools.Select })
							}
						>
							<Icon name="mouse pointer" />
						</Button>
						<Button
							icon
							primary={this.state.tool === Tools.Pan}
							onClick={() => this.setState({ tool: Tools.Pan })}
						>
							<Icon name="move" />
						</Button>
						<Popup
							trigger={
								<Button
									style={{
										backgroundColor: this.state.lineCol,
										color: "white",
									}}
								>
									Line Color
								</Button>
							}
							eventsEnabled={true}
							on="click"
						>
							<SketchPicker
								color={this.state.lineCol}
								onChangeComplete={(col) =>
									this.setState({ lineCol: col.hex })
								}
							/>
						</Popup>

						<Popup
							open={this.state.openLW}
							onOpen={() => this.setState({ openLW: true })}
							onClose={() => this.setState({ openLW: false })}
							trigger={<Button>Line Width</Button>}
							eventsEnabled={true}
							on="click"
						>
							<div>{this.renderDots()}</div>
						</Popup>
						<Checkbox
							toggle
							label="Fill Color"
							checked={this.state.isFill}
							onChange={() =>
								this.setState({ isFill: !this.state.isFill })
							}
						/>
						{this.state.isFill ? (
							<Popup
								trigger={
									<Button
										style={{
											backgroundColor: this.state.fillCol,
											color: "black",
											marginLeft: "5px",
										}}
									>
										Fill Color
									</Button>
								}
								eventsEnabled={true}
								on="click"
							>
								<SketchPicker
									color={this.state.fillCol}
									onChangeComplete={(col) =>
										this.setState({ fillCol: col.hex })
									}
								/>
							</Popup>
						) : null}
						<Button onClick={this._addText}>T</Button>
						<Dropdown
							selection
							placeholder="Background"
							options={this.getBGOptions()}
							value={this.state.bgCol}
							onChange={(e, { value }) =>
								this.setState({ bgCol: value })
							}
						/>
						<Button
							icon
							labelPosition="left"
							positive
							style={{
								position: "absolute",
								bottom: "0px",
								right: "0px",
							}}
							onClick={this._download}
						>
							Download
							<Icon name="download" />
						</Button>
					</div>
					<div style={{ height: "10px" }} />
					<div style={{ border: "1px solid grey", width: "100%" }}>
						<SketchField
							ref={(c) => (this._sketch = c)}
							width={
								this.props.croppedImg
									? this.props.croppedImg.width
									: null
							}
							height={
								this.props.croppedImg
									? this.props.croppedImg.height
									: "80vh"
							}
							tool={this.state.tool}
							lineColor={this.state.lineCol}
							lineWidth={this.state.lineWidth}
							fillColor={
								this.state.isFill
									? this.state.fillCol
									: "transparent"
							}
							backgroundColor={this.state.bgCol}
						/>
					</div>
				</Grid.Column>
			</Grid>
		);
	}
}

export default HiPainter;
